var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
var DashboardHomeComponent = (function () {
    function DashboardHomeComponent(titleService) {
        this.titleService = titleService;
        this.titleService.setTitle("Dashboard | Uptime");
    }
    DashboardHomeComponent.prototype.ngOnInit = function () {
    };
    DashboardHomeComponent = __decorate([
        Component({
            selector: 'cx-dashboard-home',
            templateUrl: './dashboard-home.component.html',
        }),
        __metadata("design:paramtypes", [Title])
    ], DashboardHomeComponent);
    return DashboardHomeComponent;
}());
export { DashboardHomeComponent };
//# sourceMappingURL=dashboard-home.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/dashboard/home/dashboard-home.component.js
// module id = 261
// module chunks = 0